module.exports = __webpack_public_path__ + "static/media/default_event_image.e9d3da6e.png";